// Standard CBIC Unit of Quantity Code list, required for GSTR-1's HSN-wise
// summary. Mirrors server/src/utils/uqc-codes.js — duplicated rather than
// shared since there's no shared package between www/ and server/, same
// convention as gst.js already being duplicated client/server.
export const UQC_CODES = [
  { code: "BAG", label: "BAGS" },
  { code: "BAL", label: "BALE" },
  { code: "BDL", label: "BUNDLES" },
  { code: "BOU", label: "BILLION OF UNITS" },
  { code: "BOX", label: "BOX" },
  { code: "BTL", label: "BOTTLES" },
  { code: "BUN", label: "BUNCHES" },
  { code: "CAN", label: "CANS" },
  { code: "CBM", label: "CUBIC METERS" },
  { code: "CCM", label: "CUBIC CENTIMETERS" },
  { code: "CMS", label: "CENTIMETERS" },
  { code: "CTN", label: "CARTONS" },
  { code: "DOZ", label: "DOZENS" },
  { code: "DRM", label: "DRUMS" },
  { code: "GGK", label: "GREAT GROSS" },
  { code: "GMS", label: "GRAMMES" },
  { code: "GRS", label: "GROSS" },
  { code: "GYD", label: "GROSS YARDS" },
  { code: "KGS", label: "KILOGRAMS" },
  { code: "KLR", label: "KILOLITRE" },
  { code: "KME", label: "KILOMETRE" },
  { code: "MLT", label: "MILILITRE" },
  { code: "MTR", label: "METERS" },
  { code: "MTS", label: "METRIC TON" },
  { code: "NOS", label: "NUMBERS" },
  { code: "PAC", label: "PACKS" },
  { code: "PCS", label: "PIECES" },
  { code: "PRS", label: "PAIRS" },
  { code: "QTL", label: "QUINTAL" },
  { code: "ROL", label: "ROLLS" },
  { code: "SET", label: "SETS" },
  { code: "SQF", label: "SQUARE FEET" },
  { code: "SQM", label: "SQUARE METERS" },
  { code: "SQY", label: "SQUARE YARDS" },
  { code: "TBS", label: "TABLETS" },
  { code: "TGM", label: "TEN GRAMS" },
  { code: "THD", label: "THOUSANDS" },
  { code: "TON", label: "TONNES" },
  { code: "TUB", label: "TUBES" },
  { code: "UGS", label: "US GALLONS" },
  { code: "UNT", label: "UNITS" },
  { code: "YDS", label: "YARDS" },
  { code: "OTH", label: "OTHERS" },
];
